import './list-control-default-item.scss';

import ListControlDefaultItem from './ListControlDefaultItem';

export default ListControlDefaultItem;
